/**
 * Zoom helpers for the editor's zoom-percentage readout.
 */

/**
 * Render a React Flow zoom factor as a rounded percentage string.
 *
 * `1` → `"100%"`, `0.5` → `"50%"`, `1.234` → `"123%"`. Tiny zoom factors clamp
 * to at least `1%` so the readout never shows `0%`. Non-finite input falls back
 * to `100%`.
 */
export function formatZoomPercent(zoom: number): string {
  if (!Number.isFinite(zoom)) return '100%'
  return `${Math.max(1, Math.round(zoom * 100))}%`
}
